import { render, staticRenderFns } from "./Seleccion.vue?vue&type=template&id=559cbb91&"
import script from "./Seleccion.vue?vue&type=script&lang=js&"
export * from "./Seleccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports